'use strict';

var _ = require('lodash');
var NavigationItemDirective = function NavigationItemDirective(userSecureService, $compile, $state, $document) {
  var allowedTemplate = _.template('<a ui-sref="<%= ref %>" tabindex="-1"><%= title %></a>');
  var rejectTemplate = _.template('<span><%= title %></span>');
  return {
    restrict: 'A',
    scope: {
      itemTitle: '@',
      ref: '@',
      isAllowed: '=?'
    },
    replace: true,
    link: function link($scope, $element) {
      $scope.$on('$stateChangeSuccess', function () {
        $element.removeClass('current');
        if (_.get($state, 'current.name') === $scope.ref) {
          $element.addClass('current');
        }
        $document.find('.d3-tip').remove();
      });
      function render() {
        var template = $scope.isAllowed || _.isUndefined($scope.isAllowed) ? allowedTemplate : rejectTemplate;
        $element.empty();
        $scope.$evalAsync(function () {
          $element.append($compile(template({
            title: $scope.itemTitle,
            ref: $scope.ref
          }))($scope));
        });
      }
      $scope.$watch('isAllowed', function () {
        render();
      });
    }
  };
};
NavigationItemDirective.$inject = ['UserSecureService', '$compile', '$state', '$document'];
module.exports = NavigationItemDirective;